import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import styled, { ThemeContext, css } from 'styled-components';
import { renderStyledElementStyles, devices } from '../../helpers';
import {
  SiteBuilderModule,
  StyledHeading,
  StyledParagraph,
  StyledIconBadge,
} from '../sharedComponents';

const Wrapper = styled.div`
  ${({ theme }) =>
    renderStyledElementStyles(theme, theme.siteBuilderModules.audioModule)};

  ${({ theme }) => renderStyledElementStyles(theme, theme.module.visualStyles)};
`;

const AudioBody = styled.div`
  line-height: 0;
`;

const AudioIframe = styled.iframe`
  ${({ theme, displayStyles }) =>
    renderStyledElementStyles(theme, displayStyles?.elements?.iframe)}
`;

const AudioTitleContainer = styled.div`
  position: relative;
  display: flex;
  min-height: 75px;
  border-bottom: 1px solid;
  margin-bottom: 25px;
  ${({ theme }) =>
    theme.globalVariables.isRTL
      ? css`
          padding-right: 80px;
        `
      : css`
          padding-left: 80px;
        `}
`;

const AudioTextContainer = styled.div`
  margin-top: 30px;

  @media (min-width: ${devices.breakpoints.laptop}) {
    margin-top: 0;
    padding-left: 20px;
  }
`;
export function AudioModule(props) {
  const {
    section: {
      id,
      title,
      titleSize,
      text,
      soundcloudurl,
      backgroundColorType = 'WHITE',
    } = {},
  } = props;

  const themeConfig = useContext(ThemeContext);
  const accentColor = themeConfig.brandConfig.colours.accent;
  const visualStyles =
    themeConfig.siteBuilderModules.audioModule.visualStyles[
      backgroundColorType
    ];
  const displayStyles =
    themeConfig.siteBuilderModules.audioModule.displayStyles.DEFAULT;

  const audioContainer = (
    <AudioTitleContainer>
      <StyledIconBadge
        iconID="volume_up"
        isRound={true}
        displayStyles={displayStyles}
      />
      <StyledHeading
        content={title}
        as={titleSize}
        displayStyles={displayStyles}
      />
    </AudioTitleContainer>
  );

  return (
    <SiteBuilderModule
      section={props.section}
      moduleTheme={{ visualStyles, displayStyles }}
    >
      <Wrapper>
        <div className="container">
          <div className="row">
            <div className="col-xs-12 visible-xs visible-sm">
              {audioContainer}
            </div>
          </div>
          <div className="row">
            <div className="col-xs-12 col-md-6">
              <AudioBody>
                <AudioIframe
                  id={id}
                  title={`soundcloud-${id}`}
                  width="100%"
                  height="450"
                  scrolling="no"
                  frameBorder="no"
                  src={`https://w.soundcloud.com/player/?url=${soundcloudurl}&visual=true&color=${accentColor}`}
                  displayStyles={displayStyles}
                />
              </AudioBody>
            </div>
            <div className="col-xs-12 col-md-6">
              <AudioTextContainer>
                <div className="hidden-xs hidden-sm">{audioContainer}</div>
                <StyledParagraph content={text} displayStyles={displayStyles} />
              </AudioTextContainer>
            </div>
          </div>
        </div>
      </Wrapper>
    </SiteBuilderModule>
  );
}

AudioModule.propTypes = {
  section: PropTypes.shape({
    id: PropTypes.string,
    title: PropTypes.string,
    titleSize: PropTypes.string,
    text: PropTypes.string,
    soundcloudurl: PropTypes.string,
    backgroundColorType: PropTypes.oneOf(['PRIMARY', 'SECONDARY', 'WHITE']),
  }).isRequired,
};

export default AudioModule;
